import { actions } from 'modules/pricing';
import { connect } from 'react-redux';
import { compose, withHandlers, withPropsOnChange, withState } from 'recompose';
import { createStructuredSelector } from 'reselect';
import view from './view';

const plansRange = ['medium', 'large', 'enterprise'];

const mapStateToProps = createStructuredSelector({});

export default compose(
  connect(mapStateToProps, actions),
  withPropsOnChange(['plan'], ({ plan }) => ({
    minimalPlan: plansRange.indexOf(plan),
  })),
  withState('chosenPlan', 'choosePlan', void 0),
  withState('action', 'setAction', void 0),
  withHandlers({
    onEnterprise:
      ({ submitContact, hideModal }) =>
      (formData) =>
        submitContact(formData).then(() => hideModal()),
    onDowngrade:
      ({ downgrade, hideModal, history, chosenPlan }) =>
      () => {
        history.push('/downgrade-success');
        downgrade({ plan: chosenPlan }).then(() => hideModal());
      },
    onSelect:
      ({
        plan,
        setAction,
        history,
        upgrade,
        hideModal,
        choosePlan,
        onSelect,
      }) =>
      (findifyPlan) => {
        if (onSelect) return onSelect(findifyPlan);
        if (findifyPlan === 'enterprise') {
          hideModal();
          return window.open(
            'https://www.findify.io/request-a-demo.html',
            '_blank'
          );
        }
        if (plansRange.indexOf(findifyPlan) < plansRange.indexOf(plan)) {
          choosePlan(findifyPlan);
          return setAction('downgrade');
        } else {
          history.push('/upgrade-success');
          return upgrade({ plan: findifyPlan }).then((response) => {
            if (response.redirectUrl) window.location = response.redirectUrl;
            hideModal();
          });
        }
      },
  })
)(view);
